import { Injectable } from '@angular/core';
import { AppInsightsService } from 'src/lib/tcs-app-insights/app-insights-initializer.service';
import { AuthenticationService } from 'src/lib/tcs-identity/authentication.service';
import { TabsService } from 'src/lib/tcs-tabs/tabs.service';
import { AppUpdaterService } from './app-updater.service';

export function initApp(appInitializer: AppInitializerService) {
  return async () => appInitializer.init();
}

@Injectable({ providedIn: 'root' })
export class AppInitializerService {
  constructor(
    private _updater: AppUpdaterService,
    private _appInsights: AppInsightsService,
    private _auth: AuthenticationService,
    private _tabs: TabsService,
  ) {}

  public async init() {
    this._tabs.init();
    await this._auth.init();
    this._appInsights.init();
    this._updater.init();
  }
}
